import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';
import { MailRequest, MailRequestEx } from '../models/mailRequest';
import { DocumentType, WhatsappRequest } from '../models/whatsappRequest';

@Component({
  selector: 'app-propertyphotodetails',
  templateUrl: './propertyphotodetails.component.html',
  styleUrls: ['./propertyphotodetails.component.scss']
})
export class PropertyphotodetailsComponent implements OnInit {

  constructor(private router:Router, private data: DataService) { }

  public photo : string;
  public photokey : string;

  ngOnInit(): void {
    this.photo = this.data.SelectedPhoto;
    this.photokey = this.photo.split('/')[3].split('?')[0];
  }

  onEmail() : boolean {
    var req: MailRequestEx = {
      MailResources : [
        {
          Title: "Property Image",
          URL: this.data.SelectedPhoto,
          ResourceType : "img"
        }
      ]
    }

    this.data.MailReqEx = req;

    this.router.navigate(['mailprogress']);
    return false;
  }

  onWhatsapp() : boolean {

    var wpreq = new WhatsappRequest
    wpreq.FileName = "PropertyImage.jpg";
    wpreq.HasMedia = true;
    wpreq.MediaUrl = this.photokey;
    wpreq.Mesage = ""; //Mostly this will be directly set by the messenger
    wpreq.MessageDocumentType = DocumentType.msgtype_propertyimage;

    this.data.WhatsappReq = wpreq;

    this.router.navigate(['whatsappprogress']);
    return false;

  }



}
